import { type DropdownItem } from '@/forms-legacy'
import { useDateFnsOptions } from '@/hooks'
import { useMemo } from 'react'
import { createAnnuallyOptions } from './utils/createAnnuallyOptions'
import { useRecurrenceState } from '../../../providers/StateProvider'
import { createDaysOfWeekOptions } from './utils/createDaysOfWeekOptions'
import { createMonthlyOptions } from './utils/createMonthlyOptions'
import { useCreateFormatRecurrenceWhenLabel } from './utils/useCreateFormatRecurrenceWhenLabel'

export function useOptions() {
  const {
    recurrencePeriod: { recurrenceType, date },
  } = useRecurrenceState()
  const { weekStartsOn, locale } = useDateFnsOptions()

  const formatRecurrenceWhenLabel = useCreateFormatRecurrenceWhenLabel()

  return useMemo<DropdownItem[]>(() => {
    switch (recurrenceType) {
      case 'NO_REPEAT':
      case 'DAILY': {
        return []
      }

      case 'WEEKLY': {
        return createDaysOfWeekOptions(weekStartsOn, formatRecurrenceWhenLabel)
      }

      case 'MONTHLY': {
        return createMonthlyOptions(date as uui.domain.YYYYMMDD, formatRecurrenceWhenLabel)
      }

      case 'ANNUALLY': {
        return createAnnuallyOptions(date as uui.domain.YYYYMMDD, formatRecurrenceWhenLabel)
      }
    }
  }, [recurrenceType, date, weekStartsOn, locale])
}
